module.exports = __webpack_public_path__ + "img/max-office-building-sync.3417cac4.svg";